import { Note } from '../../types';

export function noteTitleSlug(title: string): string {
  return title
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80) || 'untitled';
}

export function notePath(note: Pick<Note, 'publicId' | 'title'>): string {
  return `/notes/${noteTitleSlug(note.title)}--${note.publicId}`;
}

export function noteUrl(note: Pick<Note, 'publicId' | 'title'>): string {
  return new URL(notePath(note), window.location.origin).toString();
}
